import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ReferralType, BiEventType } from '@wix/da-bi/pkg/constants';
import PremiumIcon from '@wix/da-ds/pkg/Icons/Premium';
import DownloadIcon from '@wix/da-ds/pkg/Icons/24x24/Download';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { SubscriptionPurchaseFTUEContext } from '../../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import PcpPopover from '../../../PcpPopover';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ActionBarButtonRestricted from '../../_partials/ActionBarButtonRestricted';
import ActionBarButton from '../../_partials/items/ActionBarButton';
import FreeAndPcpPopover from './FreeAndPcpPopover';
// TODO: very similar to PcpButtonWithPopover, consolidate
/** Button that opens the pcp purchase and free and purchased pcp download popup */
export var DownloadButtonWithPopover = function (_a) {
    var _b;
    var deviation = _a.deviation, onDownload = _a.onDownload, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, iconRef = _a.iconRef;
    var t = useTranslation().t;
    var _c = useSubscriptionTier(deviation), isInTier = _c.isInTier, isOwner = _c.isOwner, needsSubscription = _c.needsSubscription, isSubscribedButBlocked = _c.isSubscribedButBlocked;
    var needsToPurchase = !((_b = deviation === null || deviation === void 0 ? void 0 : deviation.pcp) === null || _b === void 0 ? void 0 : _b.hasUserPurchased);
    var showMoneyIcon = isInTier
        ? needsToPurchase && needsSubscription
        : needsToPurchase && !isOwner;
    var tooltip = showMoneyIcon && isInTier
        ? t('actionbar.pcp.buyOrSubscribe')
        : t('actionbar.pcp.premiumAndFree');
    var PopupType = isSubscribedButBlocked ? PcpPopover : FreeAndPcpPopover;
    // when the user first purchases a subscription, open the tooltip and highlight the icon
    var subscriptionPurchaseFTUEPhase = useContext(SubscriptionPurchaseFTUEContext);
    var isButtonHighlighted = subscriptionPurchaseFTUEPhase === 'tooltips';
    return (React.createElement(ActionBarButtonRestricted, { forceVisibleTooltip: isButtonHighlighted, loggedInOnly: true, deviation: deviation, restrictedActionName: ReferralType.ANON_DOWNLOAD, tooltip: tooltip, renderPopover: function (_a) {
            var closeTooltip = _a.closeTooltip;
            return (React.createElement(PopupType, { deviation: deviation, closeTooltip: closeTooltip, onDownload: onDownload }));
        }, button: React.createElement(ActionBarButton, { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, biData: {
                evid: BiEventType.CLICK_DOWNLOAD_BUTTON,
                deviationid: deviation.deviationId,
                ispaiddownload: 1,
            } },
            React.createElement(ActionBarIcon, { isActive: isButtonHighlighted, icon: showMoneyIcon ? PremiumIcon : DownloadIcon, iconRef: iconRef })) }));
};
DownloadButtonWithPopover.displayName = 'DownloadButtonWithPopover';
export default DownloadButtonWithPopover;
//# sourceMappingURL=DownloadButtonWithPopover.js.map